import { render, staticRenderFns } from "./TestDetail.vue?vue&type=template&id=4d4012c9&scoped=true&"
import script from "./TestDetail.vue?vue&type=script&lang=js&"
export * from "./TestDetail.vue?vue&type=script&lang=js&"
import style0 from "./TestDetail.vue?vue&type=style&index=0&id=4d4012c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4012c9",
  null
  
)

export default component.exports